
export enum DeliveryMethod {
  None = 0,
  PDF = 1,
  AchDebit = 2,
  CovercyPayApp = 4
}

// tslint:disable-next-line:no-namespace
export namespace DeliveryMethod {
  export function toString(deliveryMethod: DeliveryMethod) {
    switch (deliveryMethod) {
      case DeliveryMethod.None:
        return 'None';
      case DeliveryMethod.PDF:
        return 'Email PDF';
      case DeliveryMethod.AchDebit:
        return 'ACH Debit';
      case DeliveryMethod.CovercyPayApp:
        return 'Covercy PayApp';
      default:
        return null;
    }
  }

  export function parse(deliverMethodStr: string): DeliveryMethod {
    return DeliveryMethod[deliverMethodStr];
  }

  export function isOn(deliverMethod: DeliveryMethod, valueToCheck: DeliveryMethod): boolean {
    // tslint:disable-next-line:no-bitwise
    return valueToCheck === (deliverMethod & valueToCheck);
  }
}

export default DeliveryMethod;
